import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import LicensePeriod from "../pages/LicensePeriod";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.License,
    key: "LicensePeriod",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={{}}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <LicensePeriod />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
